import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { Log } from "ng2-logger";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-badge-scanner',
    templateUrl: './badge-scanner.component.html',
    styleUrls: ['./badge-scanner.component.scss']
})
export class BadgeScannerComponent implements OnInit {
    _logger = Log.create(BadgeScannerComponent.name);
    focused = true;

    @Output() scan = new EventEmitter<any>();
    @Output() error = new EventEmitter<any>();

    constructor(private translateService: TranslateService) {
    }

    ngOnInit(): void {
    }


    @HostListener('window:focus', ['$event'])
    onFocus() {
        this.focused = true;
    }

    @HostListener('window:blur', ['$event'])
    onBlur() {
        this.focused = false;
    }

    onScan(boschId: string) {
        this._logger.info('onScan:: Badge scanned with ID: ' + boschId);
        this.scan.emit(boschId);
    }

    onError(boschId: string) {
        this._logger.info('onScan:: Badge scanned with error: ' + boschId);
        this.error.emit(boschId);
    }

    get scanAnimation() {
        return this.focused ? '../../../assets/images/badge_scan_enabled.gif' : '../../../assets/images/badge_scan_disabled.gif';
    }

    get scanMessage() {
        return this.focused ? this.translateService.instant('generic.scanner.focused') : this.translateService.instant('generic.scanner.notFocused')
    }
}
